














import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class GolonganDarah extends Vue {
  @Prop() setGolonganDarah: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [(v) => this.cek(v) || this.message()];

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setGolonganDarah == "" || this.setGolonganDarah == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setGolonganDarah")
  valGolonganDarah(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("golonganDarah", val);
    this.setGolonganDarah = val;
  }

  cek(v) {
    if (
      v != "" &&
      v != "A" &&
      v != "B" &&
      v != "AB" &&
      v != "O" &&
      v != "a" &&
      v != "b" &&
      v != "ab" &&
      v != "o"
    ) {
      this.setGolonganDarah = this.setGolonganDarah.substring(
        0,
        this.setGolonganDarah.length - 1
      );
      this.msg = "*Pastikan Golongan Darah diisi dengan benar";
      return false;
    } else return true;
  }
  message() {
    return this.msg;
  }
}
